import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import type { Category, ProductsAvailableFilters, ProductsResponse } from '~/services/api.server';
import type { CategoryNode } from '~/utils/shop';
import { PriceRangeFilter, PrintMethodsFilter, ProductionTimeFilter } from './common';
import ShopCategories from './ShopCategories';

type BreadcrumbEntry = { name: string; href: string };

type ShopProps = {
  isDashboard?: boolean;
  products: ProductsResponse;
  categories: Array<CategoryNode | CategoryNode[]>;
  selectedCategory?: Category;
  productsFilters: ProductsAvailableFilters;
  breadcrumbEntries: BreadcrumbEntry[];
  children: React.ReactNode;
};

export default function Shop(props: ShopProps) {
  const { products, categories, productsFilters, children, isDashboard } = props;

  return (
    <Container
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: isDashboard ? 'minmax(212px, 1fr) 4fr' : 'minmax(272px, 1fr) 4fr' },
        columnGap: 3,
      }}
      maxWidth={false}
      disableGutters
    >
      <Stack sx={{ display: { xs: 'none', sm: 'flex' }, borderRight: '1px solid rgba(0, 0, 0, 0.12)', pr: '16px' }}>
        <PrintMethodsFilter />
        <ShopCategories categories={categories} clearSearch={products.count === 0} />
        <PriceRangeFilter minMax={productsFilters.price} />
        <ProductionTimeFilter minMax={productsFilters.production_time} />
      </Stack>
      {children}
    </Container>
  );
}
